import type { StationKind } from '@/state/types';

/**
 * Block B / B3 — Alarmierungszeit (Status 2 → Status 3) pro Wachentyp.
 *
 * Wiki-Werte:
 *   BF: 45–90 s
 *   FF: 180–300 s   (Balance-Nachteil ggü. teurer BF)
 *   RD: 45–90 s
 *
 * Im Prototyp gerafft mit ALARM_TIME_RATIO = 0.3:
 *   BF: 13–27 s, FF: 54–90 s, RD: 13–27 s.
 *
 * Krankenhäuser haben keine Fahrzeuge → kein Alarm.
 */

export const ALARM_TIME_RATIO = 0.3;

interface AlarmRange {
  /** Lower bound in Wiki seconds. */
  minSec: number;
  /** Upper bound in Wiki seconds. */
  maxSec: number;
}

export const ALARM_RANGES: Record<StationKind, AlarmRange | null> = {
  'bf-station': { minSec: 45, maxSec: 90 },
  'ff-station': { minSec: 180, maxSec: 300 },
  'ems-station': { minSec: 45, maxSec: 90 },
  hospital: null,
  // Phase 10.1.2 — police alarm ranges
  'police-station': { minSec: 60, maxSec: 120 },
  'federal-police-station': { minSec: 90, maxSec: 150 },
  'riot-police-station': { minSec: 300, maxSec: 600 },
  'sek-base': { minSec: 900, maxSec: 1500 },
  courthouse: null,
};

/**
 * Random alarm duration in milliseconds, ratio-skaled. Returns 0 for hospitals
 * or unknown kinds.
 */
export function getAlarmDurationMs(kind: StationKind, rand: () => number = Math.random): number {
  const range = ALARM_RANGES[kind];
  if (!range) return 0;
  const seconds = range.minSec + rand() * (range.maxSec - range.minSec);
  return Math.round(seconds * 1000 * ALARM_TIME_RATIO);
}

/** UI helper — effective range in real-seconds for a given kind. */
export function getAlarmRangeMs(kind: StationKind): { minMs: number; maxMs: number } | null {
  const range = ALARM_RANGES[kind];
  if (!range) return null;
  return {
    minMs: Math.round(range.minSec * 1000 * ALARM_TIME_RATIO),
    maxMs: Math.round(range.maxSec * 1000 * ALARM_TIME_RATIO),
  };
}
